import type { Expression } from '../../types';

/**
 * Resolves a step's text-prompt override to a concrete string. A literal string
 * (or `undefined`) passes through untouched; an `Expression` is evaluated via
 * the supplied evaluator (the routine context's `evaluateExpression`). A
 * non-string result is a misconfiguration and throws — mirroring how the
 * capture step treats its `saveFilepath` expression.
 */
export async function resolveTextPromptOverride(
  override: string | Expression | undefined,
  evaluate: (expression: Expression) => Promise<unknown>,
): Promise<string | undefined> {
  if (override == null || typeof override === 'string') {
    return override;
  }

  const value = await evaluate(override);

  if (typeof value !== 'string') {
    throw new Error(
      `RunLocateSkill: text prompt expression must evaluate to a string, got ${typeof value}.`,
    );
  }

  return value;
}
